/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { getDrawingImageFixedSize } from "./getDrawingImageFixedSize";
import { getDrawingImageWithZoom } from "./getDrawingImageWithZoom";
import { getDrawingLineFeatures } from "./getDrawingLineFeatures";
import { getDrawingPMTilesURL } from "./getDrawingPMTilesURL";
import { getDrawingPolygonFeatures } from "./getDrawingPolygonFeatures";
import { getDrawingStatus } from "./getDrawingStatus";
import { getDrawingTextFeatures } from "./getDrawingTextFeatures";
import { getImageTileVizV1DrawingsProjectUuidFileUuidTilesXYZGet } from "./getImageTileVizV1DrawingsProjectUuidFileUuidTilesXYZGet";
import { getTileForFilesVizV1DrawingsProjectUuidTilesZoomLevelXYGet } from "./getTileForFilesVizV1DrawingsProjectUuidTilesZoomLevelXYGet";

export function drawingClient() {
  return { getDrawingStatus, getDrawingTextFeatures, getDrawingLineFeatures, getDrawingPolygonFeatures, getDrawingImageFixedSize, getDrawingPMTilesURL, getImageTileVizV1DrawingsProjectUuidFileUuidTilesXYZGet, getTileForFilesVizV1DrawingsProjectUuidTilesZoomLevelXYGet, getDrawingImageWithZoom }
}